import { PropsWithChildren } from 'react';
import styles from './FormGroup.module.scss';

type Props = {
  label?: string;
  error?: string;
  help?: string;
};

export function FormGroup({ label, children, error, help }: PropsWithChildren<Props>) {
  return (
    <div className={styles.formGroup}>
      {label && <label className={styles.formGroupLabel}>{label}</label>}

      {children}

      <span
        className={[styles.formGroupHelp, error && styles.formGroupError].filter(Boolean).join(' ')}
      >
        {error ? error : help ? help : ' '}
      </span>
    </div>
  );
}
